import { Text } from "@smartsuite/react-ui/lib/components/typography/Text/Text";

import type { DocumentDesignItem } from "../../canvas/state/types";
import { StyledSwitchButton } from "../StyledSwitchButton/StyledSwitchButton";

const HIDE = "hide";
const KEEP = "keep";

export interface SidebarSelectionConfigEmptyValueProps {
  selected: DocumentDesignItem;
  onChangeSelected: (modifiedItem: DocumentDesignItem) => void;
}

export const SidebarSelectionConfigEmptyValue: React.FC<
  SidebarSelectionConfigEmptyValueProps
> = ({ selected, onChangeSelected }) => (
  <div>
    <div style={{ marginBottom: 4 }}>
      <Text weight="medium" wrapMode="ellipsis">
        When empty
      </Text>
    </div>
    <StyledSwitchButton
      options={[
        { label: "Keep space", value: KEEP },
        { label: "Hide", value: HIDE },
      ]}
      currentValue={selected.hideWhenEmpty ? HIDE : KEEP}
      onChange={(value) =>
        onChangeSelected({ ...selected, hideWhenEmpty: value === HIDE })
      }
    />
  </div>
);
